export function SponsoredEnrollmentBootstrapLoading() {
  return (
    <div className="bg-white px-4 py-10">
      <div className="mx-auto max-w-4xl px-6 pb-20 md:px-12">
        <div className="mx-auto max-w-[42rem] overflow-hidden rounded-[30px] border border-[#FFCAAA] bg-[linear-gradient(135deg,#FFF0E8_0%,#FFFFFF_55%,#F8F8F8_100%)] shadow-[0_18px_45px_rgba(230,83,0,0.12)]">
          <div className="relative px-6 py-10 text-center md:px-10 md:py-12">
            <div className="absolute inset-x-0 top-0 h-1.5 bg-[linear-gradient(90deg,#E65300_0%,#FF8855_50%,#E65300_100%)]" />

            <div className="mx-auto mb-4 inline-flex items-center gap-2 rounded-full border border-[#FFB080] bg-white/80 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.28em] text-[#B84500] shadow-sm">
              <span className="h-2 w-2 animate-pulse rounded-full bg-[#E65300]" />
              Loading enrollment
            </div>

            <h2 className="text-[28px] font-semibold leading-tight text-[#2F241C]">
              Restoring your sponsored enrollment
            </h2>

            <p className="mx-auto mt-3 max-w-[30rem] text-sm leading-6 text-[#6A625B] md:text-[15px]">
              We&apos;re loading your saved profile and progress so we can return you to the
              correct step.
            </p>

            <div className="mx-auto mt-7 flex max-w-[18rem] items-center justify-center gap-2">
              <div className="h-2 flex-1 rounded-full bg-[#FFD9C0]">
                <div className="h-full w-2/3 animate-pulse rounded-full bg-[#E65300]" />
              </div>
              <div
                className="h-2.5 w-2.5 animate-pulse rounded-full bg-[#E65300]"
                style={{ animationDelay: '120ms' }}
              />
              <div
                className="h-2.5 w-2.5 animate-pulse rounded-full bg-[#F07843]"
                style={{ animationDelay: '240ms' }}
              />
              <div
                className="h-2.5 w-2.5 animate-pulse rounded-full bg-[#F0A080]"
                style={{ animationDelay: '360ms' }}
              />
            </div>

            <p className="mt-4 text-xs font-medium uppercase tracking-[0.22em] text-[#8C4000]">
              This should only take a moment
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
